import { Skeleton } from './ui/skeleton';

/**
 * CardSkeleton - Minimal skeleton for card loading state
 * Simple, tiny placeholder that matches CardCard proportions
 */
export function CardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-4">
      {/* Logo and title */}
      <div className="flex items-start gap-3">
        <Skeleton className="w-16 h-11 rounded-sm" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>

      {/* Stats */}
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>

      {/* Button */}
      <Skeleton className="h-10 w-full rounded-lg" />
    </div>
  );
}
